<app-stages [stages]="stages" currentStage="Treść pisma"></app-stages>
<br>
@if (!pending() && !loading()) {
  <form novalidate autocomplete="off" [formGroup]="form" (ngSubmit)="submitAndGoNext()">
    <div class="row">
      @if (form.geometry; as geometry) {
        <div class="col-12 pb-3">
          <div>
            Geometria:&nbsp;
            <button
              *ngIf='!showDrawTerrain && !form.geometry.value?.length'
              type='button'
              class='btn btn-secondary'
              (click)='showDrawTerrain = true'>
              <i class='fa fa-map' aria-hidden='true'></i>
              <span aria-hidden='true'>Dodaj</span>
              <span class='sr-only'>Dodaj geometrie</span>
            </button>
            <button
              *ngIf='!showDrawTerrain && !!form.geometry.value?.length'
              type='button'
              class='btn btn-secondary'
              (click)='showDrawTerrain = true'>
              <i class='fa fa-map-marked' aria-hidden='true'></i>
              <span aria-hidden='true'>Edytuj</span>
              <span class='sr-only'>Edytuj geometrie</span>
            </button>
            @if (form.geometry.invalid && form.geometry.touched) {
              <span class='d-inline-block ms-3 mt-3'>
                <app-alert type='danger' [closable]='false'>Pole jest wymagane</app-alert>
              </span>
            }
          </div>
          @if (showDrawTerrain) {
            <app-draw-and-modify-terrain
              [formControl]="geometry"
              (apply)="showDrawTerrain = false"
              (cancel)="showDrawTerrain = false">
            </app-draw-and-modify-terrain>
          }
        </div>
      }
      <div class="col-12">
        @if (defaultShipmentTypeValue) {
          <app-label class="mb-3" label="Rodzaj pisma:">
            {{ defaultShipmentTypeValue }}
          </app-label>
        }
      </div>
      <div class="col-12">
        <p>Czy składający wniosek jest właścicielem lub użytkownikiem wieczystym nieruchomości objętej wnioskiem lub
          uwagą? *</p>
        <br>
        <div class="form-group" *ngIf='"isPropertyOwnerOrPerpetualUser" as controlName'>
          <div class="custom-radio custom-inline" [ngClass]='{ "is-invalid": form.showError(controlName) }'>
            <input
              [formControlName]="controlName"
              type="radio"
              [id]="controlName + 'Yes'"
              [value]="true">
            <label [for]="controlName + 'Yes'">Tak</label>
          </div>
          <div class="custom-radio custom-inline" [ngClass]='{ "is-invalid": form.showError(controlName) }'>
            <input
              [formControlName]="controlName"
              type="radio"
              [id]="controlName + 'No'"
              [value]="false">
            <label [for]="controlName + 'No'">Nie</label>
          </div>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    </div>
    <div class="row">
      <div class='col-12'>
        <div class='form-group' *ngIf='"shipmentContent" as controlName'>
          <label [for]='controlName'>
            {{ application() | shipmentContentLabel }} *
          </label>
          <textarea
            rows="8"
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            [placeholder]='application() | shipmentContentPlaceholder'></textarea>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    </div>
  </form>
  <div class='application-actions'>
    <button
      type='button'
      class='btn btn-secondary'
      (click)='onCancel()'>
      <span>
        Wstecz
      </span>
    </button>
    <button
      (click)="submitAndGoNext()"
      type='button'
      class='btn btn-primary'>
      <span>Zapisz i przejdź dalej</span>
    </button>
  </div>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
